"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _mediaQueries = _interopRequireDefault(require("../../utils/media-queries"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    font-size: 16px;\n    line-height: 20px;\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var TextLarge = _styledComponents["default"].span.withConfig({
  displayName: "TextLarge",
  componentId: "sc-14fqmh7-0"
})(["font-size:18px;font-weight:400;line-height:26px;", ""], _mediaQueries["default"].handheld(_templateObject()));

var _default = TextLarge;
exports["default"] = _default;